import React, { Component } from "react";
import { accessControl } from "../../../permission/permission";
import Dropzone from "react-dropzone";
import { FaTimes, FaCloudUploadAlt, FaPlay } from "react-icons/fa";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import swal from "sweetalert";

class PhotoForm extends Component {
  constructor() {
    super();
    accessControl([1, 4]);
    this.state = {
      files: [],
      captions: {},
      uploadProgress: {},
      isUploading: false,
    };
  }

  onDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      id: Math.random().toString(36).substr(2, 9),
    }));

    this.setState((prevState) => ({
      files: [...prevState.files, ...newFiles],
    }));
  };

  removeFile = (fileId) => {
    this.setState((prevState) => ({
      files: prevState.files.filter((file) => file.id !== fileId),
      captions: Object.keys(prevState.captions)
        .filter((id) => id !== fileId)
        .reduce((obj, key) => {
          obj[key] = prevState.captions[key];
          return obj;
        }, {}),
    }));
  };

  handleCaptionChange = (fileId, e) => {
    this.setState({
      captions: {
        ...this.state.captions,
        [fileId]: e.target.value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { files, captions } = this.state;
    const { category, SubCategoryID } = this.props.data;

    if (!category || !SubCategoryID) {
      alert("Please select both category and subcategory");
      return;
    }

    if (files.length === 0) {
      alert("Please upload at least one file");
      return;
    }

    this.setState({ isUploading: true, uploadProgress: {} });

    try {
      // Create an array to track upload progress for each file
      const uploadPromises = files.map((fileObj, index) => {
        const formData = new FormData();

        // Create the object structure you want
        // const fileData = {
        //   category: category,
        //   SubCategoryID: SubCategoryID,
        //   ImageTitle: captions[fileObj.id] || "",
        //   image: "", // Will be populated by backend if needed
        //   photo: fileObj.file, // The actual file
        // };

        // Append as JSON string or individual fields
        formData.append("entry_id", SubCategoryID);
        formData.append("photo", fileObj.file);
        formData.append("photo", fileObj.file);
        formData.append("photo", fileObj.file);
        formData.append("photo", fileObj.file);

        return axios.post(`${serverLink}gallery/add`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            // Calculate progress for this individual file
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            // Update progress for this specific file
            this.setState((prevState) => ({
              uploadProgress: {
                ...prevState.uploadProgress,
                [fileObj.id]: percentCompleted,
                // Calculate overall progress
                overall: Math.round(
                  Object.values({
                    ...prevState.uploadProgress,
                    [fileObj.id]: percentCompleted,
                  }).reduce((sum, val) => sum + (typeof val === "number" ? val : 0), 0) / files.length
                ),
              },
            }));
          },
        });
      });

      // Wait for all files to upload
      const responses = await Promise.all(uploadPromises);

      // Check if all uploads were successful
      const allSuccess = responses.every((res) => res.data.message === "uploaded");

      if (allSuccess) {
        this.showSuccessAlert("success","All files uploaded successfully!","success");
        this.setState({
          files: [],
          captions: {},
          isUploading: false,
        });

        if (this.props.onSuccess) {
          this.props.onSuccess(responses.map((res) => res.data));
        }
      } else {
        throw new Error("Some files failed to upload");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Error uploading some files. Please try again.");
      this.setState({ isUploading: false });
    }
  };

  showSuccessAlert(title, msg, type) {
    return swal({
      title: title,
      text: msg,
      icon: type,
      button: "OK",
    });
  }

  componentWillUnmount() {
    // Clean up object URLs
    this.state.files.forEach((file) => URL.revokeObjectURL(file.preview));
  }

  render() {
    const { files, captions, uploadProgress, isUploading } = this.state;
    const { isLoading, data, categoryList, subCategoryList, onEdit } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="card-body" style={{ textAlign: "left" }}>
          <div
            className="scroll-y me-n7 pe-7"
            id="kt_modal_new_address_scroll text-left"
            data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}"
            data-kt-scroll-max-height="auto"
            data-kt-scroll-dependencies="#kt_modal_new_address_header"
            data-kt-scroll-wrappers="#kt_modal_new_address_scroll"
            data-kt-scroll-offset="300px"
          >
            <div className="row mb-5">
              <div className="col-md-6 fv-row">
                <label className="required fs-5 fw-bold mb-2">Category</label>
                <select className="form-control form-control-solid" name="category" id="category" onChange={onEdit} value={data.category}>
                  <option value="">Select category</option>
                  {categoryList.map((category, index) => (
                    <option key={index} value={category.EntryID}>
                      {category.CategoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6 fv-row">
                <label className="required fs-5 fw-bold mb-2">Sub Category</label>
                <select
                  className="form-control form-control-solid"
                  name="SubCategoryID"
                  id="SubCategoryID"
                  onChange={onEdit}
                  value={data.SubCategoryID}
                >
                  <option value="">Select subcategory</option>
                  {subCategoryList.map((category, index) => (
                    <option key={index} value={category.EntryID}>
                      {category.SubCategoryName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-5">
              <Dropzone onDrop={this.onDrop} accept="image/*,video/*" multiple={true}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className="dropzone p-10 border border-dashed border-gray-300 rounded text-center cursor-pointer">
                    <input {...getInputProps()} />
                    <FaCloudUploadAlt className="mx-auto text-primary" size={48} />
                    <p className="mt-3">Drag & drop files here, or click to select</p>
                    <p className="text-muted">Supports images and videos</p>
                  </div>
                )}
              </Dropzone>
            </div>

            {files.length > 0 && (
              <div className="uploaded-files mb-5">
                <h6 className="mb-3">Files to upload:</h6>
                <div className="row">
                  {files.map((fileObj) => (
                    <div key={fileObj.id} className="col-md-4 mb-3">
                      <div className="card">
                        <div className="card-body p-2">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-truncate" style={{ maxWidth: "70%" }}>
                              {fileObj.file.name}
                            </span>
                            <button type="button" className="btn btn-sm btn-icon btn-danger" onClick={() => this.removeFile(fileObj.id)}>
                              <FaTimes />
                            </button>
                          </div>

                          {fileObj.file.type.startsWith("image/") ? (
                            <img src={fileObj.preview} alt="Preview" className="img-fluid mb-2" style={{ maxHeight: "100px" }} />
                          ) : (
                            <div className="bg-light d-flex justify-content-center align-items-center mb-2" style={{ height: "100px" }}>
                              <FaPlay size={24} />
                            </div>
                          )}

                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Add caption (optional)"
                            value={captions[fileObj.id] || ""}
                            onChange={(e) => this.handleCaptionChange(fileObj.id, e)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {isUploading && (
              <div className="progress mb-5">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{ width: `${uploadProgress.overall || 0}%` }}
                  aria-valuenow={uploadProgress.overall || 0}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {uploadProgress.overall || 0}%
                </div>
              </div>
            )}

            <button
              type="submit"
              id="kt_modal_new_address_submit"
              disabled={isUploading || isLoading}
              className="btn btn-primary w-25 offset-sm-4 mb-9 mt-9"
            >
              {isUploading ? (
                <>
                  Uploading...
                  <span className="spinner-border spinner-border-sm ms-2"></span>
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default PhotoForm;
